import { render, staticRenderFns } from "./page-demo-player.vue?vue&type=template&id=1df9a7e6&scoped=true&"
import script from "./page-demo-player.vue?vue&type=script&lang=js&"
export * from "./page-demo-player.vue?vue&type=script&lang=js&"
import style0 from "./page-demo-player.vue?vue&type=style&index=0&id=1df9a7e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df9a7e6",
  null
  
)

export default component.exports